import './loader.css';

export default function LoaderKitsProduct() {
    function randomNumber(min:number, max:number) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    const KitItems = () => {
        let content = [];
        for (let i = 0; i < randomNumber(6,18); i++) content.push(<div className="product__kit_item loader-1" key={'kitLoaderItem'+i}></div>)
        return (<>{content}</>);
    }
    const KitGroup = ({width}:any) => (
        <div className="product__kit">
            <div className="product__kit_header">
                <div className={`product__kit_name product__kit_name-${width} loader-1`}></div>
                <div className={`product__kit_tags product__kit_tags-${4-width} loader-1`}></div>
            </div>
            <div className="product__kit_items">
                <KitItems />
            </div>
        </div>
    )
    return (
        <>
           <KitGroup width={1}/>
           <KitGroup width={2}/>
           <KitGroup width={3}/>
        </>
    )
}